import { map, flatMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import {
  DataService,
  ApiService,
  InspectionPluginService,
  MachineFamillyService,
  LanguageService
} from '../../../shared/services/index';
import { Icons } from '../../../shared/models';
import * as _ from 'lodash';
import { InstallationObservationFactoryService } from './observationandrecommendations-plugin-factory.service';

@Injectable()
export class InstallationObservationPluginService extends InspectionPluginService {
  public responsiblesKeys: any = [
    { value: -1, label: 'plugins.observation.Aucun' },
    { value: 0, label: 'plugins.observation.Bobst' },
    { value: 1, label: 'plugins.observation.Customer' },
    { value: 2, label: 'plugins.observation.Shared' }
  ];

  public responsibles: any = [];

  public prioritiesKeys: any = [
    { value: 0, label: 'plugins.observation.High' },
    { value: 1, label: 'plugins.observation.Medium' },
    { value: 2, label: 'plugins.observation.Low' },
    { value: -1, label: 'plugins.observation.Aucun' }
  ];

  public priorities: any = [];

  public machines: any[];

  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private machineService: MachineFamillyService,
    private language: LanguageService,
    private observationFacotry: InstallationObservationFactoryService
  ) {
    super(apiService, dataService, null, observationFacotry);
    this.machineService.getModels().subscribe((data) => (this.machines = data));

    this.applyTranslation();
    this.language.onLanguageChange().subscribe((value) => {
      this.applyTranslation();
    });
  }

  public updateObservationsAndRecommendations(
    inspectionId: string,
    pointId: string,
    pluginId: string,
    data: any,
    messageInfo: any
  ): Observable<any> {
    return this._updateObservationsAndRecommendations(inspectionId, pointId, pluginId, data, messageInfo).pipe(
      map((res: any) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  public getResponsibles() {
    return this.responsibles;
  }

  public getPriorities() {
    return this.priorities;
  }

  public getMachines() {
    return this.machines;
  }

  getMachineName(id: string): string {
    const obj = _.find(this.getMachines(), ['id', id]);
    return obj ? obj.name : '';
  }

  getMachineId(name: string): string {
    const obj = _.find(this.getMachines(), ['name', name]);
    return obj ? obj.id : '';
  }

  public deletePlugin(inspectionId: string, pointId: string, pluginId: string): any {
    return super.deletePlugin(inspectionId, pointId, pluginId).pipe(
      map((success) => {
        this.dataService.processIcons(false, Icons.getIconByName(Icons.observationIconName), inspectionId, pointId);
        return success;
      })
    );
  }

  private _updateObservationsAndRecommendations(
    inspectionId: string,
    pointId: string,
    pluginId: string,
    observations: any,
    messageInfo: any
  ): Observable<any> {
    const data = { ObservationsAndRecommendations: observations, MessageInfo: messageInfo };
    return this.observationFacotry.updateObservationsAndRecommendations(inspectionId, pointId, pluginId, data).pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }

  private applyTranslation() {
    this.responsibles = [];
    this.priorities = [];
    this.copyTranslationValues(this.responsiblesKeys, this.responsibles, this.language);
    this.copyTranslationValues(this.prioritiesKeys, this.priorities, this.language);
  }
}
